import React, { useState } from "react";
import Modal from "../Common/Modal";
import RadioButton from "../Buttons/RadioButton";
import SuiteApi from "../../api/SuiteApi";
import { EImagingMode } from "../../Model/EImagingMode";
import SpinnerTextBox from "../Controls/SpinnerTextBox";
import "./ImagingModeModal.css";

const MANUAL = "MANUAL";
const AUTOMATIC = "AUTOMATIC";

type Props = {
  show: boolean;
  onHide: () => void;
  onOk?: () => void;
  onCancel?: () => void;
  hideOnBackDropClick?: boolean;
  name?: string; // to add into radio button id
};

export default function ImagingMode({
  show,
  onHide,
  onOk = () => {},
  onCancel = () => {},
  hideOnBackDropClick = true,
  name = "",
}: Props) {
  const [activationMode, setActivationMode] = useState(AUTOMATIC);
  const [waitTimeAutoMode, setWaitTimeAutoMode] = useState(1);

  const onClickChangeMode = () => {
    switch (activationMode) {
      case AUTOMATIC:
        SuiteApi.setImagingMode(EImagingMode.Manual).then(() => {
          SuiteApi.setImagingModeWithDelay(
            EImagingMode.Automatic,
            waitTimeAutoMode * 60
          ).then(() => {
            onHide();
            onOk();
          });
        });

        break;
      case MANUAL:
        SuiteApi.setImagingMode(EImagingMode.Manual).then(() => {
          onHide();
          onOk();
        });
        break;
      default:
        break;
    }
  };

  const onClickCancel = () => {
    onCancel();
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      hideOnBackdropClick={hideOnBackDropClick}
    >
      <Modal.Header
        title="Resume Scheduled Imaging"
        hideButtonEnabled={false}
      />
      <Modal.Body className="imaging-mode-modal-content">
        <p>
          You’re about to switch to Manual Mode. How do you want to resume
          scheduled imaging?
        </p>
        <div style={{ display: "flex" }} className="selection">
          <RadioButton
            id={name + AUTOMATIC}
            name={"group" + name + AUTOMATIC + MANUAL}
            checked={activationMode === AUTOMATIC}
            label="Automatically"
            onChange={() => setActivationMode(AUTOMATIC)}
          />
          <span>&nbsp;in&nbsp;</span>
          <SpinnerTextBox
            disabled={false}
            value={waitTimeAutoMode}
            onValueChanged={(value) => setWaitTimeAutoMode(value)}
            step={1}
            min={1}
            max={1440}
            style={{ width: 77, fontSize: 20 }}
          />
          <span>&nbsp;minutes</span>
        </div>
        <RadioButton
          id={name + MANUAL}
          name={"group" + name + AUTOMATIC + MANUAL}
          checked={activationMode === MANUAL}
          label="Manually"
          onChange={() => setActivationMode(MANUAL)}
          className="selection"
        />
      </Modal.Body>
      <Modal.Footer
        onClickCancel={onClickCancel}
        onClickOk={onClickChangeMode}
      />
    </Modal>
  );
}
